export const initComments = () => {
  const iframe = document.querySelector('#ghost-comments-root iframe');

  if (iframe) {
    iframe.addEventListener('load', () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      iframeDoc.head.insertAdjacentHTML(
        'beforeend',
        `<style>

            section.dark button[data-testid="signin-button"] {
              color: inherit !important;
            }

            section[data-testid="cta-box"] h1:first-child{
              color: #000000;
            }

            section[data-testid="cta-box"] p{
              color: #606060;
            }

            section.dark section[data-testid="cta-box"] h1:first-child{
            color: #fff;
            }
            section.dark section[data-testid="cta-box"] p{
              color: #acacac;
            }

          </style>`
      );
    });
  }
};
